import request from './request'

const $http = {}
$http.post = (url, params) => {
  return request({
    url,
    method: 'post',
    data: params
  })
}

$http.get = (url, params) => {
  return request({
    url,
    method: 'get',
    params
})
}

export default $http


// WEBPACK FOOTER //
// ./src/utils/http.js